import React, { useState } from 'react'
import Image from 'next/legacy/image'
import { useRouter } from 'next/router'
import {
  MobileMoreDropdownMenu,
  MyDropdownMenu,
} from 'components/misc/header/header-dropdown-menu'
import { TriggerExceptTarget } from 'components/misc/trigger'
import { HiOutlineChatAlt2 } from 'react-icons/hi'
import { FiSearch, FiUser } from 'react-icons/fi'
import { useStores } from 'stores/globals'
import { AlertBadge } from 'components/common/badge'
import { StartupSearchModal } from 'components/misc/startup-search-modal'
import { useUser } from 'apis/hooks'
import { ChatIcon } from 'components/common/icon'
import { theme } from 'infra/theme'
import {
  MobileTabMenu,
  MobileTabMenuContainer,
  MobileTabMenuText,
} from 'components/misc/header/styles'

const MobileHeaderTabs = () => {
  const ICON_SIZE = 20
  const router = useRouter()
  const { loginStore } = useStores()
  const { data: user } = useUser({ ssr: false })
  const [isMyDropdownOpen, setIsMyDropdownOpen] = useState(false)
  const [isMoreDropdownOpen, setIsMoreDropdownOpen] = useState(false)
  const [isOpenSearchModal, setIsOpenSearchModal] = useState(false)
  const isScoutSelected = router.pathname === '/landing'
  const isPositionSelected =
    (router.asPath.includes('/positions') &&
      !router.pathname.includes('my-activities')) ||
    router.asPath.includes('/startups/')
  const isMySelected = router.asPath.includes('/my-page')
  const isMoreSelected = router.asPath.includes('/programs')

  return (
    <>
      <MobileTabMenuContainer>
        {!user && (
          <MobileTabMenu onClick={() => router.push('/landing')}>
            <HiOutlineChatAlt2 size={ICON_SIZE} color={theme.color.black2} />
            <MobileTabMenuText isSelected={isScoutSelected}>
              스카우트
            </MobileTabMenuText>
          </MobileTabMenu>
        )}
        <MobileTabMenu onClick={() => router.push('/positions')}>
          <FiSearch size={ICON_SIZE} color={theme.color.black2} />
          <MobileTabMenuText isSelected={isPositionSelected}>
            채용 공고
          </MobileTabMenuText>
        </MobileTabMenu>
        {user && (
          <MobileTabMenu onClick={() => router.push('/chat-rooms')}>
            <div style={{ position: 'relative' }}>
              {user?.newMessageCount !== 0 && (
                <AlertBadge top={-3} right={-4} size={12} />
              )}
              <ChatIcon size={ICON_SIZE + 2} strokeWidth={0.1} />
            </div>
            <MobileTabMenuText
              isSelected={router.pathname.includes('chat-rooms')}
            >
              채팅
            </MobileTabMenuText>
          </MobileTabMenu>
        )}
        <TriggerExceptTarget onTrigger={() => setIsMyDropdownOpen(false)}>
          <MobileTabMenu
            onClick={() => {
              if (user) {
                setIsMyDropdownOpen((prev) => !prev)
              } else {
                loginStore.setIsModalOpen(true)
              }
            }}
          >
            <FiUser size={ICON_SIZE} color={theme.color.black2} />
            <MobileTabMenuText
              isSelected={
                user
                  ? router.pathname.includes('my-profile') ||
                    router.pathname.includes('my-activities') ||
                    router.pathname.includes('interested-in-me') ||
                    router.pathname.includes('my-page')
                  : isMySelected
              }
            >
              {user ? 'MY' : '로그인'}
            </MobileTabMenuText>
            {isMyDropdownOpen && <MyDropdownMenu />}
          </MobileTabMenu>
        </TriggerExceptTarget>
        <TriggerExceptTarget onTrigger={() => setIsMoreDropdownOpen(false)}>
          <MobileTabMenu onClick={() => setIsMoreDropdownOpen((prev) => !prev)}>
            <Image
              src={`/gnb-more.svg`}
              width={ICON_SIZE}
              height={ICON_SIZE}
              alt='더보기'
              priority
            />
            <MobileTabMenuText isSelected={isMoreSelected}>
              더보기
            </MobileTabMenuText>
            {isMoreDropdownOpen && (
              <MobileMoreDropdownMenu
                openSearchModal={() => setIsOpenSearchModal(true)}
              />
            )}
          </MobileTabMenu>
        </TriggerExceptTarget>
      </MobileTabMenuContainer>
      {isOpenSearchModal && (
        <StartupSearchModal onClose={() => setIsOpenSearchModal(false)} />
      )}
    </>
  )
}

export default MobileHeaderTabs
